<div>
  <ng-content select="[pre]"></ng-content>
</div>
<div class="title">
  <div class="small">
    <ng-content select="small"></ng-content>
  </div>
  <div class="main">
    <ng-content select="h1"></ng-content>
  </div>
</div>
<div class="centered">
  <ng-content select="[centered]"></ng-content>
</div>
<div class="aside margin-left-auto">
  <ng-content select="[aside]"></ng-content>
</div>
